import { useCampaignSlug } from '@/core/app/useCampaignSlug'
import { resolveLocale, withLangParam } from '@/core/i18n/publicPageLocale'

/**
 * 現在のロケールと、Auth / Docs 画面へのリンクに `lang` クエリを付けるヘルパーを返す。
 *
 * `locale` は API の `X-Local` ヘッダー（`useCampaignHeaders`）と同じ値になる。
 * `withLang()` は既定ロケール（ja_JP）のときや `http(s)` 以外の URL では何もしない。
 *
 * @example
 * const { withLang } = useLocale()
 * const faqUrl = withLang(`${process.env.NEXT_PUBLIC_DOCS_URL}/faq`)
 */
export const useLocale = (): { locale: string; withLang: (url: string) => string } => {
  const { LOCAL_STORAGE_I18N_KEY } = useCampaignSlug()
  // localStorage の同期読み出し 1 回のみ。言語変更時は必ず window.location.reload() が
  // 走る（LanguageDialog）ため、リアクティブに追随させる必要が無い
  const locale = resolveLocale(LOCAL_STORAGE_I18N_KEY)

  return {
    locale,
    withLang: (url: string) => withLangParam(url, locale),
  }
}
